module.exports = __webpack_public_path__ + "static/media/novartis_interno.4f2452b0.png";